<template>
  <div class="k-flex-item" :style="gridItemStyles">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'KFlex',
  props: {
    cols: {
      type: [Number,String],
      default: 12
    },
    c1: { type: Boolean, default: false },
    c2: { type: Boolean, default: false },
    c3: { type: Boolean, default: false },
    c4: { type: Boolean, default: false },
    c5: { type: Boolean, default: false },
    c6: { type: Boolean, default: false },
    c7: { type: Boolean, default: false },
    c8: { type: Boolean, default: false },
    c9: { type: Boolean, default: false },
    c10: { type: Boolean, default: false },
    c11: { type: Boolean, default: false },
    c12: { type: Boolean, default: false },
  },
  computed: {
    gridItemStyles() {
      var cols = this.cols;
      if (this.c1) cols = 1;
      else if (this.c2) cols = 2;
      else if (this.c3) cols = 3;
      else if (this.c4) cols = 4;
      else if (this.c5) cols = 5;
      else if (this.c6) cols = 6;
      else if (this.c7) cols = 7;
      else if (this.c8) cols = 8;
      else if (this.c9) cols = 9;
      else if (this.c10) cols = 10;
      else if (this.c11) cols = 11;
      else if (this.c12) cols = 12;
      return {
        gridColumn: `span ${cols}`
      }
    }
  }
};
</script>

<style scoped>
.k-flex-item {
  box-sizing: border-box;

}
</style>